[
    {
        "Select": {
            "editable": false,
            "pinned": "left",
            "refData": {
                "datatype": "checkbox",
                "selectAll": true,
                "colSize": 50
            },
            "maxWidth": 50,
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Job Name": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "flexSize": 2,
                "minWidth": 200
            },
            "rowGroup": false,
            "hide": false
        },
        "Job Tag": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Channel": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Top Product Node": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Buying Season": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Prior Selling Season(s)": {
            "editable": false,
            "refData": {
                "datatype": "array",
                "arrayKey": "season",
                "customNullValue": "Custom Season",
                "showToolTip": false,
                "custom_field": "prior_selling_seasons"
            },
            "rowGroup": false,
            "hide": false
        },
        "Styc CT": {
            "editable": false,
            "refData": {
                "datatype": "number",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false
        },
        "Size Range": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": true,
                "tooltipField": "size_range",
                "colSize": 100
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Last Modified By": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "flexSize": 2
            },
            "rowGroup": false,
            "hide": false,
            "suppressAutoSize": true
        },
        "Last Modified": {
            "editable": false,
            "refData": {
                "datatype": "date",
                "showToolTip": false
            },
            "rowGroup": false,
            "hide": false,
            "sort": "desc"
        },
        "Status": {
            "editable": false,
            "refData": {
                "datatype": "string",
                "showToolTip": false,
                "showAlert": true,
                "customAlertCompRef": "job-management-status-alert",
                "alertConditions": ["failed", "completed with errors"],
                "alertLinks": {
                    "completed with errors": {
                        "link": "/size-distro-execution/job-exceptions",
                        "key": "job_name",
                        "action": "filter"
                    },
                    "failed": {
                        "link": "/size-distro-execution/job-exceptions",
                        "key": "job_name",
                        "action": "filter"
                    }
                },
                "flexSize": 2,
                "minWidth": 300
            },
            "rowGroup": false,
            "hide": false
        },
        "Copy": {
            "editable": false,
            "refData": {
                "datatype": "open-screen|copy",
                "displayBlankHeader": true
            },
            "rowGroup": false,
            "hide": false
        },
        "Edit": {
            "editable": false,
            "refData": {
                "datatype": "open-screen|settings",
                "displayBlankHeader": true
            },
            "rowGroup": false,
            "hide": false
        }
    }
]
